import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { BillableMetric } from 'src/features/billableMetrics/utils/types';
import { billableMetricsMessages } from 'src/features/billableMetrics/utils/messages';
import UpdateBillableMetricFormModal from 'src/features/billableMetrics/components/forms/UpdateBillableMetricFormModal';
import DeleteBillableMetricFormModal from 'src/features/billableMetrics/components/forms/DeleteBillableMetricFormModal';

/** No dashboard button - billable metrics have no dashboard route. */
export default function CellBillableMetricActions({ row }: CellContext<BillableMetric, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateBillableMetricFormModal
                        semantics={{ entryName: formatMessage(billableMetricsMessages.billableMetric).toLowerCase() }}
                        selectedBillableMetric={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateBillableMetricFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteBillableMetricFormModal selectedBillableMetric={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteBillableMetricFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
